// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__2gPZD","linkText":"styles_linkText__bXYXs","link":"styles_link__32hSY","active":"styles_active__3eH0m"};